import { makeStyles } from '@material-ui/styles'

export const useQuestionCommentsStyle = makeStyles((theme) => ({
  commentsBlock: {},
}))
